(function () {
  'use strict';

  /* Google Apps Script Web App URL */
  var APP_SCRIPT_URL =
    'https://script.google.com/macros/s/AKfycbwixVvf51mNAKvSiqK6AsAyTAAHfh7K0CtLMghRnz9JW67Ny-6BeNCBzqqhzY2ZyryE/exec';

  var REQUEST_KEY =
    'BMKkNpD6W5bhPMn89u3mJyxbh5rnt1lVXLlLh4SoHa8';

  var REQUEST_TIMEOUT = 30000;
  var activeButton = null;
  var activeFrame = null;
  var requestTimer = null;
  var activeRequestId = null;
  var activeCustomerEmail = '';
  var backendMessageReceived = false;

  function numberValue(value) {
    var number = Number(value);
    return isFinite(number) ? number : 0;
  }

  function normalizeEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function createRequestId() {
    return (
      'b2b-' +
      Date.now() +
      '-' +
      Math.random().toString(36).slice(2, 12)
    );
  }

  function createCartSignature(items) {
    return items
      .map(function (item) {
        return item.variant_id + ':' + item.quantity;
      })
      .join('|');
  }

  function normalizeItems(rawItems) {
    if (!Array.isArray(rawItems)) return [];

    return rawItems
      .map(function (item) {
        return {
          variant_id: numberValue(
            item.variant_id || item.variantId || item.id
          ),
          quantity: Math.max(1, numberValue(item.quantity)),
          selected_price: numberValue(item.selected_price),
          retail_price: numberValue(item.retail_price),
          retailer_price: numberValue(item.retailer_price),
          distributor_price: numberValue(item.distributor_price),
          institution_price: numberValue(item.institution_price),
          is_free_item: item.is_free_item === true
        };
      })
      .filter(function (item) {
        return item.variant_id > 0;
      });
  }

  function buildRequest(rawPayload) {
    var rawItems =
      rawPayload.items ||
      (rawPayload.cart && rawPayload.cart.items) ||
      [];

    var items = normalizeItems(rawItems);

    if (!items.length) {
      throw new Error('Your cart is empty.');
    }

    var customer = rawPayload.customer || {};
    var customerId =
      rawPayload.customerId ||
      rawPayload.customer_id ||
      customer.id ||
      '';

    var customerEmail = normalizeEmail(
      rawPayload.customerEmail ||
      rawPayload.email ||
      customer.email ||
      ''
    );

    if (!customerId) {
      throw new Error('Please log in before placing a B2B order.');
    }

    if (!customerEmail) {
      throw new Error('Logged-in customer email was not found.');
    }

    var requestId = createRequestId();

    return {
      requestSecret: REQUEST_KEY,
      requestId: requestId,
      source: rawPayload.source || 'cart',
      customerId: String(customerId),
      customerEmail: customerEmail,
      customer: {
        id: String(customerId),
        email: customerEmail,
        type: customer.type || '',
        tags: customer.tags || []
      },
      cartSignature: createCartSignature(items),
      returnUrl: window.location.href,
      cart: {
        token:
          rawPayload.cart_token ||
          (rawPayload.cart && rawPayload.cart.token) ||
          '',
        note:
          rawPayload.note ||
          (rawPayload.cart && rawPayload.cart.note) ||
          '',
        currency:
          rawPayload.currency ||
          (rawPayload.cart && rawPayload.cart.currency) ||
          'INR',
        items: items
      }
    };
  }

  function getMinimumOrderDetails(button) {
    var customerType = String(
      button.getAttribute('data-b2b-customer-type') || ''
    ).toLowerCase();

    var minimum = numberValue(
      button.getAttribute('data-b2b-minimum-order')
    );

    var current = numberValue(
      button.getAttribute('data-b2b-order-total')
    );

    if (!minimum) {
      minimum =
        customerType === 'distributor' ? 5000000 : customerType === 'institution' ? 1500000 : customerType === 'retailer' ? 2000000 : 0;
    }

    return {
      customerType: customerType,
      minimum: minimum,
      current: current,
      remaining: Math.max(0, minimum - current)
    };
  }

  function formatINR(cents) {
    return '₹' + (numberValue(cents) / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  function validateMinimumOrder(button) {
    var details = getMinimumOrderDetails(button);

    if (details.minimum > 0 && details.current < details.minimum) {
      throw new Error(
        'Minimum order value is ' +
          formatINR(details.minimum) +
          '. Please add ' +
          formatINR(details.remaining) +
          ' more to continue.'
      );
    }
  }

  function getPayload(button) {
    validateMinimumOrder(button);

    var payloadId = button.getAttribute('data-payload-id');

    var payloadElement = payloadId
      ? document.getElementById(payloadId)
      : document.getElementById('b2b-cart-json') ||
        document.querySelector('[data-b2b-cart-json]');

    if (!payloadElement) {
      throw new Error('B2B cart payload was not found.');
    }

    var rawText =
      payloadElement.textContent || payloadElement.value || '';

    if (!rawText.trim()) {
      throw new Error('B2B cart payload is empty.');
    }

    return buildRequest(JSON.parse(rawText.trim()));
  }

function setButtonState(button, loading) {
  if (!button) return;

  if (loading) {
    if (!button.dataset.originalText) {
      button.dataset.originalText = button.textContent;
    }

    button.disabled = true;
    button.textContent = 'Placing Order...';
    button.setAttribute('aria-busy', 'true');
  } else {
    button.disabled = false;

    if (button.dataset.originalText) {
      button.textContent = button.dataset.originalText;
    }

    button.removeAttribute('aria-busy');
  }
}
  function cleanupRequest() {
    if (requestTimer) {
      window.clearTimeout(requestTimer);
    }

    requestTimer = null;

    if (activeFrame && activeFrame.parentNode) {
      activeFrame.parentNode.removeChild(activeFrame);
    }

    activeFrame = null;
  }

  function resetRequestState() {
    cleanupRequest();
    setButtonState(activeButton, false);
    activeButton = null;
    activeRequestId = null;
    activeCustomerEmail = '';
    backendMessageReceived = false;
  }

  function getInvoiceUrl(data) {
    return (
      data.invoiceUrl ||
      data.checkoutUrl ||
      data.invoice_url ||
      (data.orderData &&
        (data.orderData.invoiceUrl ||
          data.orderData.checkoutUrl ||
          data.orderData.invoice_url)) ||
      (data.draftOrder &&
        (data.draftOrder.invoiceUrl ||
          data.draftOrder.checkoutUrl ||
          data.draftOrder.invoice_url)) ||
      ''
    );
  }

  function getResponseEmail(data) {
    return normalizeEmail(
      data.customerEmail ||
      data.sheetCustomerEmail ||
      (data.orderData && data.orderData.customerEmail) ||
      ''
    );
  }

  function injectSuccessModalStyles() {
    if (document.getElementById('hizzar-b2b-success-style')) return;

    var style = document.createElement('style');
    style.id = 'hizzar-b2b-success-style';
    style.textContent =
      '.hizzar-b2b-modal{position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(17,24,39,.68);backdrop-filter:blur(3px);}' +
      '.hizzar-b2b-modal__card{width:100%;max-width:480px;background:#fff;border-radius:18px;padding:32px 26px;text-align:center;box-shadow:0 24px 70px rgba(0,0,0,.28);animation:hizzarB2BPop .22s ease-out;}' +
      '.hizzar-b2b-modal__icon{width:72px;height:72px;margin:0 auto 18px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#eaf8ef;color:#16803d;font-size:38px;font-weight:700;}' +
      '.hizzar-b2b-modal__title{margin:0 0 12px;font-size:25px;line-height:1.25;color:#111827;}' +
      '.hizzar-b2b-modal__text{margin:0;color:#4b5563;font-size:15px;line-height:1.7;}' +
      '.hizzar-b2b-modal__email{margin:18px 0 0;padding:13px 15px;border-radius:10px;background:#f3f4f6;color:#111827;font-size:14px;word-break:break-word;}' +
      '.hizzar-b2b-modal__button{width:100%;margin-top:24px;border:0;border-radius:10px;padding:14px 18px;background:#111827;color:#fff;font-size:15px;font-weight:700;cursor:pointer;}' +
      '.hizzar-b2b-modal__button:hover{opacity:.92;}' +
      '@keyframes hizzarB2BPop{from{opacity:0;transform:translateY(12px) scale(.97)}to{opacity:1;transform:translateY(0) scale(1)}}';

    document.head.appendChild(style);
  }

  function showSuccessPopup(data, email) {
    injectSuccessModalStyles();

    var existingModal = document.getElementById(
      'hizzar-b2b-success-modal'
    );

    if (existingModal) {
      existingModal.remove();
    }

    var modal = document.createElement('div');
    modal.id = 'hizzar-b2b-success-modal';
    modal.className = 'hizzar-b2b-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    var card = document.createElement('div');
    card.className = 'hizzar-b2b-modal__card';

    var icon = document.createElement('div');
    icon.className = 'hizzar-b2b-modal__icon';
    icon.textContent = '✓';

    var title = document.createElement('h2');
    title.className = 'hizzar-b2b-modal__title';
    title.textContent = 'Order Successfully Placed';

    var text = document.createElement('p');
    text.className = 'hizzar-b2b-modal__text';
    text.textContent =
      'Your invoice has been sent to your registered email address. Please check your Inbox, Spam or Promotions folder.';

    var emailBox = document.createElement('div');
    emailBox.className = 'hizzar-b2b-modal__email';
    emailBox.textContent = 'Invoice sent to: ' + email;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'hizzar-b2b-modal__button';
    button.textContent = 'OK';

    function closeModalAfterCartClear() {
      if (button.disabled) return;

      button.disabled = true;
      button.textContent = 'Please wait...';

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Unable to clear the cart.');
          }

          return response.json();
        })
        .then(function () {
          modal.remove();
          document.body.style.overflow = '';
          window.location.href = '/';
        })
        .catch(function (clearError) {
          console.error('Cart clear failed:', clearError);

          button.disabled = false;
          button.textContent = 'OK';

          alert(
            'Order was placed successfully, but the cart could not be cleared. Please try again.'
          );
        });
    }

    // Popup remains open until the customer clicks OK.
    button.addEventListener('click', closeModalAfterCartClear);

    card.appendChild(icon);
    card.appendChild(title);
    card.appendChild(text);
    card.appendChild(emailBox);
    card.appendChild(button);
    modal.appendChild(card);
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    button.focus();
  }

  function submitDraftOrder(payload) {
    cleanupRequest();

    activeRequestId = payload.requestId;
    activeCustomerEmail = normalizeEmail(payload.customerEmail);
    backendMessageReceived = false;

    var frameName =
      'hizzar-b2b-' +
      Date.now() +
      '-' +
      Math.random().toString(36).slice(2, 10);

    var iframe = document.createElement('iframe');
    iframe.name = frameName;
    iframe.setAttribute('title', 'Processing B2B order');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.style.display = 'none';

    var formSubmitted = false;
    var responseHandled = false;

    function openFallbackSuccessPopup() {
      if (responseHandled || backendMessageReceived) return;
      if (!activeRequestId || activeRequestId !== payload.requestId) return;

      responseHandled = true;
      var fallbackEmail = activeCustomerEmail;

      resetRequestState();
      showSuccessPopup(
        {
          success: true,
          fallback: true
        },
        fallbackEmail
      );
    }

    iframe.addEventListener('load', function () {
      // First iframe load means the hidden frame is ready.
      if (!formSubmitted) {
        formSubmitted = true;

        var form = document.createElement('form');
        form.method = 'POST';
        form.action = APP_SCRIPT_URL;
        form.target = frameName;
        form.style.display = 'none';

        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'payload';
        input.value = JSON.stringify(payload);

        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
        form.remove();
        return;
      }

      // Second load is the Apps Script response page.
      // Show popup even when postMessage is not received.
      window.setTimeout(openFallbackSuccessPopup, 300);
    });

    iframe.src = 'about:blank';
    document.body.appendChild(iframe);
    activeFrame = iframe;

    requestTimer = window.setTimeout(function () {
      if (backendMessageReceived || responseHandled) return;

      cleanupRequest();
      setButtonState(activeButton, false);
      activeButton = null;
      activeRequestId = null;
      activeCustomerEmail = '';

      console.warn('B2B order processing timed out.');
    }, REQUEST_TIMEOUT);
  }

  window.addEventListener('message', function (event) {
    var allowedOrigin =
      event.origin === 'https://script.google.com' ||
      event.origin.indexOf('https://script.googleusercontent.com') === 0 ||
      event.origin === 'null';

    if (!allowedOrigin) return;

    var data = event.data;

    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        return;
      }
    }

    if (!data || data.source !== 'hizzar-draft-order') return;

    if (!activeRequestId || data.requestId !== activeRequestId) return;

    backendMessageReceived = true;

    if (data.success !== true) {
      var backendError =
        data.message ||
        data.error ||
        'Unable to create or update the B2B Draft Order.';

      resetRequestState();
      alert(backendError);
      return;
    }

    if (data.sheetMatched !== true) {
      resetRequestState();
      alert(
        data.sheetMessage ||
          'Customer email was not matched in Google Sheet.'
      );
      return;
    }

    var responseEmail = getResponseEmail(data);

    if (!responseEmail) {
      resetRequestState();
      alert('Matched customer email was not returned by the backend.');
      return;
    }

    if (responseEmail !== activeCustomerEmail) {
      resetRequestState();
      alert(
        'Security check failed: logged-in customer email does not match the Google Sheet email.'
      );
      return;
    }

    if (data.customerEmailSent !== true || data.adminEmailSent !== true) {
      var emailError =
        data.emailMessage ||
        'The Draft Order was created, but the customer or admin email could not be sent.';

      resetRequestState();
      alert(emailError);
      return;
    }

    var invoiceUrl = getInvoiceUrl(data);

    if (!invoiceUrl) {
      resetRequestState();
      alert(
        'Customer email matched, but Invoice URL is empty in Google Sheet.'
      );
      return;
    }

    /*
     * Order successful:
     * - invoice URL is available
     * - email is sent by Apps Script
     * - no automatic invoice redirect
     * - frontend success popup is shown
     */
    resetRequestState();

    showSuccessPopup(data, responseEmail);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      '[data-hizzar-b2b-button], ' +
        '[data-autobros-b2b-button], ' +
        '[data-b2b-cart-button], ' +
        '#b2b-place-order'
    );

    if (!button) return;

    event.preventDefault();

    if (button.disabled || activeRequestId) return;

    try {
      activeButton = button;
      setButtonState(button, true);

      var payload = getPayload(button);
      window.HizzarB2BCartData = payload;

      submitDraftOrder(payload);
    } catch (error) {
      console.error('Hizzar B2B error:', error);
      resetRequestState();
      alert(
        error && error.message
          ? error.message
          : 'Unable to process the B2B order.'
      );
    }
  });
})();
